import { FETCH_ORDERS_BY_STATUS_SUCCESS, FETCH_ORDERS_BY_STATUS_REQUEST, FETCH_ORDERS_BY_STATUS_FAILURE, FETCH_ORDERS_BY_STATUS_RESET, } from "@/redux/actions";
const initialState = {
    fetchOrders: [],
    loading: false,
    error: null,
};
const getOrdersByStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDERS_BY_STATUS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, fetchOrders: action.payload });
        case FETCH_ORDERS_BY_STATUS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, fetchOrders: null, error: null });
        case FETCH_ORDERS_BY_STATUS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_ORDERS_BY_STATUS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, fetchOrders: null });
        default:
            return state;
    }
};
export default getOrdersByStatusReducer;
